import styled from 'styled-components'
import * as BaseStyles from '../BaseStyles'

export const TeamContainerDiv = styled(BaseStyles.Div)`
    padding: 1.2rem 2rem;
`

export const TeamContainerContentsDiv = styled(BaseStyles.Div)`
    margin: 0rem auto;
    min-width: 20rem;
    max-width: 140rem;    
`

export const TeamContentsDiv = styled(BaseStyles.Div)`
    box-shadow:
    0 0px 2px rgba(0, 0, 0, 0.022),
    0 0px 3px rgba(0, 0, 0, 0.031),
    0 0px 4px rgba(0, 0, 0, 0.039),
    0 0px 5px rgba(0, 0, 0, 0.048),
    0 0px 6px rgba(0, 0, 0, 0.07)
    ;   
    background-color: white;
    border-radius: 1.5rem;
    padding: 1.2rem;
`

export const TeamSectionHeader = styled(BaseStyles.SectionHeader)`
    color: black;
`

export const TeamMemberContainerDiv = styled(BaseStyles.Div)`
    padding: 0.5rem 0.1rem;
    padding-bottom: 1.2rem;
    white-space: nowrap;
    overflow-x: scroll;
    overflow-y: hidden;
`